import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import "./style.css";

class AddPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {
        price: "",
        name: "",
      },
    };
  }

  updateData = (field, value) => {
    const { price } = this.state;
    this.setState({
      price: {
        ...price,
        [field]: value,
      },
    });
  };

  handleClick = () => {
    const { handleChange } = this.props;
    const { price } = this.state;
    handleChange(price);
    this.setState({
      price: {
        price: "",
        name: "",
      },
    });
  };

  render() {
    return (
      <Card className="addPrice">
        <CardHeader className="panel-heading">Přidat položku ceníku</CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-md-12">
              <Input
                type="text"
                min={1}
                className="amount"
                value={this.state.price.price}
                placeholder="Cena"
                onChange={(e) => this.updateData("price", e.target.value)}
              />
            </div>
          </div>
          <InputGroup className="priceName">
            <Input
              value={this.state.price.name}
              placeholder="Název položky"
              onChange={(e) => this.updateData("name", e.target.value)}
            />
            <InputGroupAddon addonType="append">
              <Button
                color="secondary"
                onClick={this.handleClick}
                disabled={!this.state.price.name.length > 0}
              >
                Vytvořit
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </CardBody>
      </Card>
    );
  }
}

export default AddPrice;



// WEBPACK FOOTER //
// ./src/modules/Pricing/PriceList/AddItem.js